module.exports = __webpack_public_path__ + "img/woman-happy.8b681ccc.svg";